import { writable } from "svelte/store";

import AuthActions from "./AuthActions";
import AuthHelpers from "./AuthHelpers";

import AuthState from "./Enums/AuthState";
import AuthChallenge from "./Enums/AuthChallenge";

import Company from "../Models/Company";
import User from "../Models/User";
import Signal from "signals";

const AuthStore = {
	meta: {
		version: __VERSION,
		state: writable(AuthState.LOGGED_OUT),
		challenge: {
			type: writable(AuthChallenge.NONE),
			session: writable("")
		}
	},
	events: {
		onStartLogout: new Signal(),
		onFinishLogout: new Signal()
	},
	forms: {
		login: {
			username: writable(""),
			password: writable(""),
			error: writable(""),
			submitting: writable(false)
		},
		forgotPassword: {
			codeDelivery: {
				method: writable(""),
				destination: writable("")
			},
			username: writable(""),
			code: writable(""),
			newPassword: writable(""),
			newPasswordConfirm: writable(""),
			error: writable(""),
			submitting: writable(false),
			success: writable(false)
		},
		challenges: {
			current: writable(""),
			session: writable(""),

			changePassword: {
				newPassword: writable(""),
				error: writable("")
			}
		}
	},
	token: writable(AuthHelpers._generateEmptyToken()),
	userInfo: writable(AuthHelpers._generateEmptyUserInfo()),
	session: { // TODO: consider moving this.
		rois: writable([]),
		alertTypes: writable([]),
		company: writable(new Company({})),
		user: writable(new User({}))
	},
	actions: { ...AuthActions },
	helpers: { ...AuthHelpers }
};

export default AuthStore;
